import AjaxService from '@services/AjaxService';
import BaseRepository from '@repositories/desktop/BaseRepository';

export default class TuevSuedStatusRepository extends BaseRepository {
  protected baseUrl = '/api/desktop/tuev-sued-status';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService);
  }

  public loadStatus(): Promise<any> {
    return this.ajaxService.getJson(this.baseUrl);
  }
}
